import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

/**
 * Font weights that are not needed for the first paint. Loading them after
 * the page has rendered keeps the render-blocking stylesheet small; the
 * metric-matched fallbacks in index.css keep the swap shift-free.
 */
const loadDeferredFonts = () => {
  void import("@fontsource/playfair-display/latin-400.css");
  void import("@fontsource/playfair-display/latin-400-italic.css");
  void import("@fontsource/playfair-display/latin-500.css");
  void import("@fontsource/playfair-display/latin-600.css");
  void import("@fontsource/source-sans-3/latin-300.css");
  void import("@fontsource/source-sans-3/latin-500.css");
  void import("@fontsource/source-sans-3/latin-700.css");
};

const scheduleDeferredFonts = () => {
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(loadDeferredFonts, { timeout: 3000 });
  } else {
    setTimeout(loadDeferredFonts, 1200);
  }
};

if (document.readyState === "complete") scheduleDeferredFonts();
else window.addEventListener("load", scheduleDeferredFonts, { once: true });
